import * as dd from 'dingtalk-jsapi'
import Platform from "./platform"
import http from "@/utils/http";
import {getQuery,locationTo} from "../utils/url"
import {initDebug} from "../utils/commons"

import {Toast} from "vant"

class PlatformDingtalk extends Platform {
    constructor(params) {
        super(params)
        this._setCorpIdAndAgentId(getQuery('corpId'), getQuery('agentId'))
    }

    init() {
        initDebug()
        return new Promise((resolve, reject) => {
            let self = this;
            self._initAuth(resolve, reject);
            /*if(self.signatureCheckSuccess){
                self._initAuth(resolve, reject)
            }else{
                self.config().then(resp => {
                    self._initAuth(resolve, reject)
                }).catch(err => {
                    console.log(err)
                    reject(err);
                });
            }*/
        })
    }

    config() {
        let self = this;
        return new Promise((resolve, reject) => {
            http.get('/ding/getConfig.htm', {
                url: window.location.href.split('#')[0],
                agentId: self.agentId
            }).then(resp => {
                let DI_API = [
                    'device.audio.startRecord',
                    'device.audio.stopRecord',
                    'device.audio.onRecordEnd',
                    'device.audio.translateVoice'];
                let config = {
                    corpId: resp.corpId,
                    timeStamp: resp.timeStamp,
                    nonceStr: resp.nonceStr,
                    signature: resp.signature,
                    agentId: self.agentId,
                    jsApiList: DI_API,
                    type:0
                };
                dd.config(config)
                dd.ready(()=>{
                    self.signatureCheckSuccess = true;
                    resolve();
                })
                dd.error(error => {
                    console.error('钉钉jssdk权限验证失败', error)
                    reject(error)
                })
            })
        })
    }

    close() {
        dd.ready(() => dd.biz.navigation.close())
    }

    setTitle(title) {
        dd.ready(() => dd.biz.navigation.setTitle({title: title,}))
    }

    hideOptionMenu() {
        dd.ready(() => dd.biz.navigation.setRight({
            show: false,//控制按钮显示， true 显示， false 隐藏， 默认true
            control: false,//是否控制点击事件，true 控制，false 不控制， 默认false
            text: '',//控制显示文本，空字符串表示显示默认文本
        }))
    }

    openChat(userIds, groupName = '') {
        dd.ready(() => dd.biz.util.open({
            name: "chat",
            params: {
                users: [userIds],
                corpId: this.corpId
            },
            onFail: function (err) {
                console.error(`创建会话失败, userIds: ${userIds}`, err)
                if (err.errorCode == "4") Toast('该用户未绑定钉钉')
            }
        }))
    }

    _setCorpIdAndAgentId(corpId, agentId) {
        this.corpId = corpId
        this.agentId = agentId
        sessionStorage.setItem('corpId', this.corpId)
        sessionStorage.setItem('agentId', this.agentId)
    }

    _initAuth(resolve, reject) {
        var key = 'ding.requestAuthCode.onsuccess';
        // 避免页面之间跳转时重复登录
        if (sessionStorage.getItem(key) === 'true'){
            resolve && resolve();
            return;
        }
        dd.ready(() => {
            dd.runtime.permission.requestAuthCode({corpId: this.corpId})
                .then(authResult => {
                    http.get('/ding/auth.htm', {code: authResult.code, agentId: this.agentId}).then(resp=>{
                        if(resp && resp.code === '0'){
                            sessionStorage.setItem(key, 'true');
                            resolve();
                        }else if (resp && resp.code == '3') {
                            locationTo.href("unidentified-dingtalk.html")
                            reject(resp)
                        } else {
                            reject(resp)
                        }
                    }).catch(reject)
                })
                .catch(reject)
        })
    }
}

export default PlatformDingtalk
